import React, { useState, useEffect } from 'react';
import './scmMemberSelectStakeholder.css';
import { useNavigate, useLocation } from "react-router-dom";
import { ADD_MULTIPLE_TRAINING_MATERIAL } from '../../../../common/URLs';

import { loaderService } from "../../../../common/custom-loader/loader-service";
import { getLocalStorageItem } from '../../../../common/localStorageUtils';
import { PROD } from '../../../../common/constants';
import { Container, Stack, Typography, Grid, Button } from '@mui/material';
import BackButton from '../../../../common/backButton';
import { ConfirmationPopover } from '../../../../common/commonPopovers/confirmationPopover';
import { toast } from 'react-toastify';
import apiClient from '../../../../axios';

function ScmMemberSelectStakeholder() {

    function importAll(r) {
        let images = {};
        r.keys().map((item, index) => { images[item.replace('./', '')] = r(item); });
        return images;
    }
    const images = importAll(require.context('../../../../images/', false, /\.(png|jpe?g|svg)$/));

    const [data, setData] = useState([
        {
            id: 1,
            img: images['bamboo-with-leaves.png'],
            title: 'Grower',
            subtitle: 'SubCategory of Growers are JFMC, SHG, Forest, FPO, FPC and Goverment',
            selected: false,
            checkBoxSelected: false
        },
        {
            id: 2,
            img: images['harvest.png'],
            title: 'HIT',
            subtitle: 'Harvester Cum Interim Transporter',
            selected: false,
            checkBoxSelected: false
        },
        {
            id: 3,
            img: images['lle.png'],
            title: 'LLE',
            subtitle: 'Local Level Enterprenuer',
            selected: false,
            checkBoxSelected: false
        },
        {
            id: 4,
            img: images['cargo-truck.png'],
            title: 'Transporter',
            subtitle: '',
            selected: false,
            checkBoxSelected: false
        },
        {
            id: 5,
            img: images['storage.png'],
            title: 'Interim Storage Operator',
            subtitle: '',
            selected: false,
            checkBoxSelected: false
        }
    ]);

    const navigate = useNavigate();
    const { state } = useLocation();
    const { documentsArr, comment, link } = state;
    const [scmKMSubmitted, setScmKMSubmitted] = useState();
    const [stakeHolderArr, setStakeHolderArr] = useState([]);
    const [downloadbleStakeHolderArr, setDownloadbleStakeHolderArr] = useState([]);
    const [fileDownloadable, setFileDownloadable] = useState(false);
    const [trainingMaterialArr, setTrainingMaterialArr] = useState();
    const [logConfirmModalOpen, setLogConfirmModalOpen] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleConfirmLogModalOpen = () => setLogConfirmModalOpen(true);
    const handleConfirmLogModalClose = () => setLogConfirmModalOpen(false);

    const onSelectStakeHolder = (e, selectedItem) => {
        e.preventDefault();
        const tempArr = (data?.map(item => {
            if (item.title === selectedItem.title) {
                item.selected = !item.selected
            }
            return item
        }
        ))
        setData(tempArr);
    };

    const onCheckBoxSelect = (e, itemTitle) => {
        const tempArr = (data?.map(item => {
            if (item.title === itemTitle) {
                item.checkBoxSelected = !item.checkBoxSelected
            }
            return item
        }
        ))
        setData(tempArr);
    }

    const onSubmit = (e) => {
        e.preventDefault();
        handleConfirmLogModalOpen();
    }

    function onConfirmCallBack() {
        if (isSubmitting) return; 
        
        setIsSubmitting(true);
        handleConfirmLogModalClose();
        
        let arrayData = []
        let downloadableArrayData = []
        data?.map((item) => {
            if (item.selected === true) {
                arrayData.push(item?.title);
            }
            if (item.checkBoxSelected === true) {
                downloadableArrayData.push(item?.title);
            }
        })
        setStakeHolderArr(arrayData);
        setDownloadbleStakeHolderArr(downloadableArrayData);
    }

    function onCancelBack() {
        handleConfirmLogModalClose();
    }

    useEffect(() => {
        if (stakeHolderArr?.length !== 0) {
            const tempArr = trainingMaterialArr ? [...trainingMaterialArr] : []
            documentsArr.map((item) => {
                tempArr.push({
                    "fileName": item?.fileName,
                    "filetype": null,
                    "fileSize": null,
                    "fileDownloadable": null,
                    "fileStorage": item?.blobFileName,
                    "comment": comment,
                    "externalVideoLink": link,
                    "stakeholderList": stakeHolderArr,
                    "dwnldbleStkhldrLst": downloadbleStakeHolderArr,
                })
            });
            setTrainingMaterialArr(tempArr);
        }
    }, [stakeHolderArr]);


    useEffect(() => {
        if (trainingMaterialArr?.length !== 0) {
            getScmKMSubmitted();
        }
    }, [trainingMaterialArr]);

    useEffect(() => {
        if (scmKMSubmitted) {
            if (scmKMSubmitted.status === "SUCCESS") {
                toast.success(scmKMSubmitted?.description);
                navigate('/resourcedashboard/home');
            }
            else {
                toast.error(scmKMSubmitted?.description);
                setIsSubmitting(false); 
            }
        }
    }, [scmKMSubmitted]);

    function getScmKMSubmitted() {
        loaderService.showLoader();
        apiClient
            .post(ADD_MULTIPLE_TRAINING_MATERIAL,
                {
                    "getTrainingMaterialList": trainingMaterialArr
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setScmKMSubmitted(response.data);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log("apiClientERROR", error);
                loaderService.hideLoader();
                setIsSubmitting(false); 
            });
    }

    return (
        <>
            <Container maxWidth="xxl">
                {!PROD && <p className='pageNumberingResc'>RES08</p>}
                <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                    <BackButton navigate={navigate} />
                    <Typography variant="h5" gutterBottom>
                        Select Stakeholder
                    </Typography>
                </Stack>
                <Grid container spacing={1}>
                    {data.map(item => (
                        <Grid item xs={12} md={12} lg={5} key={item.id}>
                            <div className={item.selected === true ? 'stakeholder_container_SCM selected' : 'stakeholder_container_SCM'} onClick={(e) => onSelectStakeHolder(e, item)}>
                                <img className="grower_stakeholder_img" src={item?.img} alt="grower_bamboo_img" />
                                <div className='flex-column'>
                                    <p className={item?.subtitle !== '' ? 'text_Stakeholder_SCM' : 'text_Stakeholder_SCM noSubTitle'}>{item?.title}</p>
                                    <p className='Stakeholder_subtext_SCM'>{item?.subtitle}</p>
                                </div>
                            </div>
                        </Grid>
                    ))}
                </Grid>
                <Grid container spacing={1}>
                    <Grid item xs={12} md={12} lg={12}>
                        {
                            (data?.some(item => item.selected)) && <><div className='KM-file-download-text'>Make file downloadable for</div>
                                <div className="radio-FileDownload">
                                    {data.map(item => (item?.selected &&
                                        <React.Fragment key={item.id}>
                                            <input type="checkBox" name="optradio" onChange={(e) => onCheckBoxSelect(e, item?.title)} />
                                            <label className='KM_checkbox-text'>{item?.title}</label>
                                        </React.Fragment>
                                    ))}
                                </div>
                            </>
                        }
                    </Grid>
                    <Grid item xs={12} lg={12} display='flex' justifyContent="flex-end">
                        <Button 
                            disabled={isSubmitting} 
                            sx={{ minWidth: 100 }} 
                            className="RescProceed" 
                            variant="contained" 
                            onClick={(e) => onSubmit(e)}
                        >
                            {isSubmitting ? "submitting..." : "submit"}
                        </Button>
                    </Grid>
                </Grid>
            </Container>
            <ConfirmationPopover onOpen={logConfirmModalOpen} onConfirm={onConfirmCallBack} onClose={onCancelBack} action="Submit" />
        </>
    )
}

export default ScmMemberSelectStakeholder;
